import SkuCardMobile from '../../cards/sku/mobile/SkuCardMobile';
import { Autoplay } from 'swiper/modules';
import { getReactKey } from '@/utilites/react/react.util';
import { SkusCarouselMobileProps } from '@/types/props/components/skus';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export default function SkusCarouselMobile({
  skus,
  userId,
}: SkusCarouselMobileProps) {
  return (
    <Swiper
      spaceBetween={16}
      slidesPerView={2}
      breakpoints={{
        0: {
          slidesPerView: 1.2,
          spaceBetween: 12,
        },
        325: {
          slidesPerView: 1.8,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }}
      loop={true}
      modules={[Autoplay]}
      autoplay={false}
      height={350}
      className="tw-overflow-x-clip tw-overflow-y-visible"
    >
      {skus.map((sku, index) => (
        <SwiperSlide
          key={getReactKey.skuCarousel.mobile(sku, index)}
          className="!tw-h-[282px]  tw-max-w-[170px]"
        >
          <SkuCardMobile sku={sku} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
